export const BOOKING_LINK = '[BOOKING LINK]'
export const BOOK_LABEL = 'Book Your Free Call'

export const navLinks = [
  { label: 'How It Works', href: '#how-it-works' },
  { label: 'Why Us', href: '#why-us' },
  { label: 'FAQ', href: '#faq' },
  { label: 'Contact Us', href: '/contact-us' },
]

export const trustItems = [
  { icon: 'users', count: 144, before: 'More than ', after: ' veterans guided' },
  { icon: 'medical', count: null, before: 'Team of former military medical personnel', after: '' },
  { icon: 'oneOnOne', count: null, before: 'One-on-one, start to finish', after: '' },
] as const

// Listed in official order of precedence. Names only — no official seals or emblems.
export const branches = ['Army', 'Marine Corps', 'Navy', 'Air Force', 'Space Force', 'Coast Guard', 'National Guard']

export const familyCards = [
  {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/f54a571c-ceea-49f7-abd1-9ea130887941.jpg',
    alt: "A small child's hand holding a parent's hand, the parent's sleeve in a plain utility uniform.",
    line: 'For the ones who counted the days.',
  },
  {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/c46b82fe-acc8-4c79-95f2-97e1c36d0363.jpg',
    alt: 'A couple seen from behind sitting on porch steps at dusk, his arm around her shoulders.',
    line: 'For the one who held it together.',
  },
  {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/ecc20400-bcaa-4baf-a53f-df91db078277.jpg',
    alt: 'An older mother hugging her adult son tightly at the front door of a home.',
    line: 'For the ones who never stopped worrying.',
  },
]

export const frustrations = [
  {
    quote: 'Nobody listened.',
    answer: 'We start by hearing your story. All of it.',
  },
  {
    quote: 'I got ghosted.',
    answer: 'You get one person who knows your file and answers you.',
  },
  {
    quote: "I don't know where to start.",
    answer: "You don't have to. We walk you through each step.",
  },
]

export const steps = [
  {
    title: 'Free first call.',
    body: 'Tell us your story. We listen and answer your questions.',
  },
  {
    title: 'Pick your date.',
    body: 'Reserve your working session on our calendar.',
  },
  {
    title: 'We work it together.',
    body: 'We sit down with you and go head to toe through your conditions, your records, and your statements.',
  },
  {
    title: 'We stay with you.',
    body: 'We check on your claim and help when the VA asks for more.',
  },
]

export const whyPoints = [
  'A real person who listens, for as long as it takes',
  'People who understand both the military and the medical side',
  'Straight talk about what to expect',
  'Nothing hidden. We explain our whole process',
]

// Slider holds up to 3 testimonials. Add more here when the client provides them.
export const testimonials = [
  {
    quote:
      'Working with this team made the VA process manageable. They provided clear guidance, answered every question, and helped me secure the rating I had earned.',
    attribution: 'USMC Veteran',
  },
]

// Video story slots — swap each placeholder for a real video when the client supplies one.
export const videoStories = [
  { id: 'story-1', label: 'Veteran story — video coming soon.' },
  { id: 'story-2', label: 'Veteran story — video coming soon.' },
  { id: 'story-3', label: 'Veteran story — video coming soon.' },
]

export const freeCallPoints = [
  { lead: 'You talk.', rest: 'We listen to your whole story.' },
  { lead: 'You ask anything.', rest: 'We answer straight.' },
  { lead: 'You decide.', rest: 'No pressure, no obligation.' },
]

export const services = [
  {
    title: 'Guided Claim Support',
    body: 'We work alongside you from first call to final decision.',
    comingSoon: false,
  },
  {
    title: 'One-Day Working Session',
    body: 'One focused day, everything handled together.',
    comingSoon: false,
  },
  {
    title: 'Do-It-Yourself Class',
    body: 'Small-group class that teaches our full process.',
    comingSoon: true,
  },
]

export const faqs = [
  { question: 'How long does this take?', answer: '[CLIENT TO PROVIDE]' },
  { question: 'What does it cost?', answer: '[CLIENT TO PROVIDE]' },
  { question: 'Do I have to do paperwork myself?', answer: '[CLIENT TO PROVIDE]' },
  { question: 'What if I was already denied?', answer: '[CLIENT TO PROVIDE]' },
  {
    question: 'Are you part of the VA?',
    answer:
      'No. Veterans For Life is a private, veteran-owned company. We are not affiliated with or endorsed by the Department of Veterans Affairs.',
  },
]
